<template>
	<div>
		<ViewAlbumEmbedCarousel
			v-if="carousel"
			:album="album"
		/>

		<ViewAlbumEmbed
			v-else
			:album="album"
		/>
	</div>
</template>

<script>
import { httpClient } from '@shared/js/api/httpClient';
import { EventFilter } from '@shared/enums/EventFilter';
import ViewAlbumEmbedCarousel from './ViewAlbumEmbedCarousel.vue';
import ViewAlbumEmbed from './ViewAlbumEmbed.vue';

export default {
	name:       'ViewDynamicAlbum',
	components: { ViewAlbumEmbedCarousel, ViewAlbumEmbed },
	props:      {
		albumId: {
			type:    Number,
			default: null,
		},
	},
	data: function() {
		return {
			carousel:         true,
			count:            10,
			filters:          null,
			sortOrder:        null,
			invalidUrlParams: false,
			album:            {
				events:    [],
				isLoading: true,
			},
		};
	},
	mounted: function() {
		this.applyUrlParams();
		this.loadEvents();
	},
	methods: {
		applyUrlParams() {
			const params = new URLSearchParams(window.location.search);
			const count = Number.parseInt(params.get('count'), 10);
			const defaultCount = this.albumId ? 9 : 10;

			this.carousel = params.has('carousel');
			this.count = Number.isInteger(count) && count > 0 ? count : defaultCount;
			this.filters = this.parseJsonParam(params, 'filters');
			this.sortOrder = this.parseJsonParam(params, 'sortOrder');

			if (this.albumId) {
				this.filters = {
					...(this.filters || {}),
					[EventFilter.ARENA_ALBUM]: this.albumId,
				};
			}
		},
		parseJsonParam(params, key) {
			if (!params.has(key)) {
				return null;
			}

			try {
				const parsedValue = JSON.parse(params.get(key));
				if (!parsedValue || typeof parsedValue !== 'object' || Array.isArray(parsedValue)) {
					this.invalidUrlParams = true;
					return null;
				}

				return parsedValue;
			} catch (_error) {
				// Never turn a malformed filtered embed into an unfiltered public event listing.
				this.invalidUrlParams = true;
				return null;
			}
		},
		async loadEvents() {
			try {
				if (this.invalidUrlParams) {
					return;
				}

				const opts = {
					page:    1,
					perPage: this.count,
					locale:  window.locale,
				};

				if (this.filters) {
					opts.filters = JSON.stringify(this.filters);
				}
				if (this.sortOrder) {
					opts.sortOrder = JSON.stringify(this.sortOrder);
				}
				const response = await httpClient.getDynamicAlbumEvents(opts);
				if (response.status === 200) {
					this.album = {
						events: response.data?.data || [],
					};
				}
			} catch (error) {
				// shows empty album
				this.album = {
					events: [],
				};
			} finally {
				this.album.isLoading = false;
				this.$nextTick(() => {
					if (typeof window.sendHeightToParent === 'function') {
						window.sendHeightToParent();
					}
				});
			}
		},
	},
};
</script>

<style>

</style>
